import React, { lazy, Suspense } from "react";
import { Switch, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import { PrivateRoute } from "shared/PrivateRoute";

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <PrivateRoute
          section={"contacts"}
          path={`${APP_PREFIX_PATH}/contacts`}
          component={lazy(() => import(`./ContactsPage`))}
          exact
        />
        <PrivateRoute
          section={"contacts"}
          path={`${APP_PREFIX_PATH}/contacts/:id`}
          component={lazy(() => import(`./SingleContactPage`))}
          exact
        />
        <PrivateRoute
          section={"contacts"}
          path={`${APP_PREFIX_PATH}/contacts/:id/info`}
          component={lazy(() =>
            import(`./SingleContactPage/Redesign/ContactInfoPage`)
          )}
          exact
        />
        <PrivateRoute
          section={"contacts"}
          path={`${APP_PREFIX_PATH}/contacts/:id/appointments`}
          component={lazy(() =>
            import(`./SingleContactPage/Redesign/AppointmentsPage`)
          )}
          exact
        />
        <PrivateRoute
          section={"contacts"}
          path={`${APP_PREFIX_PATH}/contacts/:id/loyalty`}
          component={lazy(() =>
            import(`./SingleContactPage/Redesign/LoyaltyPage`)
          )}
          exact
        />
        <PrivateRoute
          section={"contacts"}
          path={`${APP_PREFIX_PATH}/contacts/:id/billing`}
          component={lazy(() =>
            import(`./SingleContactPage/Redesign/BilingAndPaymentsPage`)
          )}
          exact
        />
        <PrivateRoute
          section={"contacts"}
          path={`${APP_PREFIX_PATH}/contacts/:id/memberships`}
          component={lazy(() =>
            import(`./SingleContactPage/Redesign/MembershipsPage`)
          )}
          exact
        />
        <PrivateRoute
          section={"funnels"}
          path={`${APP_PREFIX_PATH}/funnels`}
          component={lazy(() => import(`./FunnelsPage`))}
        />
        <PrivateRoute
          section={"settings"}
          path={`${APP_PREFIX_PATH}/settings`}
          component={lazy(() => import(`./SettingsPage`))}
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/email-builder/form-type-builder/:id`}
          component={lazy(() =>
            import(`./HtmlBuilderPage/EditorPage/formTypeEditorPage.js`)
          )}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/email-builder/templates/`}
          component={lazy(() => import(`./HtmlBuilderPage`))}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/email-builder/template/:id/email/:emailId`}
          component={lazy(() =>
            import(`./HtmlBuilderPage/EditorPage/formTypeEditorPage.js`)
          )}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/email-builder/:id`}
          component={lazy(() => import(`./HtmlBuilderPage/SingleTemplate`))}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/forms`}
          component={lazy(() => import("./FormBuilderPage"))}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/forms/builder/:id?`}
          component={lazy(() => import("./FormBuilderPage/FormBuilder"))}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/ads`}
          component={lazy(() => import("./AdsPage"))}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/webhooks`}
          component={lazy(() => import("./WebhooksPage"))}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/chat-widget`}
          component={lazy(() => import("./ChatWidgetPage"))}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/campaigns`}
          component={lazy(() => import(`./CampaignsPage`))}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/sms-builder`}
          component={lazy(() => import(`./SmsBuilderPage`))}
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/campaigns/:id`}
          component={lazy(() => import(`./CampaignsPage/SingleCampaignPage`))}
          exact
        />
        <PrivateRoute
          section={"conversations"}
          path={`${APP_PREFIX_PATH}/conversations`}
          component={lazy(() => import(`./ConversationsPage`))}
          exact
        />
        <PrivateRoute
          section={"conversations"}
          path={`${APP_PREFIX_PATH}/conversations/call-report`}
          component={lazy(() => import(`./CallReportPage`))}
          exact
        />
        <PrivateRoute
          section={"conversations"}
          path={`${APP_PREFIX_PATH}/inbox`}
          component={lazy(() => import(`features/inbox`))}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/landing-page`}
          component={lazy(() => import(`./LandingPage`))}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/landing-page/templates`}
          component={lazy(() =>
            import(`./LandingPage/LandingPageTemplates/index`)
          )}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/landing-page/:id`}
          component={lazy(() => import(`./LandingPage/SingleLandingPage`))}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/landing-page-builder/:id`}
          component={lazy(() => import(`./LandingPage/LandingPageBuilder`))}
          exact
        />
        <PrivateRoute
          path={`${APP_PREFIX_PATH}/edit-profile`}
          component={lazy(() => import(`./../app-views/components/Profile`))}
          exact
        />
        <PrivateRoute
          path={`${APP_PREFIX_PATH}/edit-password`}
          component={lazy(() =>
            import(`./../app-views/components/ChangePassword`)
          )}
          exact
        />
        <PrivateRoute
          path={`${APP_PREFIX_PATH}/not-found`}
          component={lazy(() => import(`../auth-views/errors/error-page-1`))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/practice-staff`}
          component={lazy(() => import(`./DoctorsPage`))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/practice-staff/create`}
          component={lazy(() => import(`./DoctorsPage/CreateDoctorPage`))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/practice-staff/:id`}
          component={lazy(() => import(`./DoctorsPage/SingleDoctorsPage`))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/practice-info`}
          component={lazy(() => import(`./PracticeInfoPage`))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/employee-calendar`}
          component={lazy(() => import(`./EmployeeCalendar`))}
          exact
        />
        <PrivateRoute
          section={"dashboard"}
          path={`${APP_PREFIX_PATH}/dashboard/`}
          component={lazy(() => import("./MainDashboard"))}
          exact
        />
        <PrivateRoute
          section={"dashboard"}
          path={`${APP_PREFIX_PATH}/dashboard-summary/`}
          component={lazy(() => import("./DashboardPage"))}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/embed-code/`}
          component={lazy(() => import("./EmbedCodePage"))}
          exact
        />
        <PrivateRoute
          section={"loyalty-program"}
          path={`${APP_PREFIX_PATH}/awards/`}
          component={lazy(() => import("./AwardsPage"))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/documents/`}
          component={lazy(() => import("./Documents"))}
          exact
        />
        <PrivateRoute
          section={"loyalty-program"}
          path={`${APP_PREFIX_PATH}/loyalty-users/`}
          component={lazy(() => import("./LoyaltyUsersPage"))}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/campaigns/contacts/:id`}
          component={lazy(() =>
            import("./CampaignsPage/SingleCampaignPage/ContactsOnCampaignPage")
          )}
          exact
        />
        <PrivateRoute
          section={"reporting"}
          path={`${APP_PREFIX_PATH}/transactions/`}
          component={lazy(() => import("./ReportingsPage/TransactionsPage"))}
          exact
        />
        <PrivateRoute
          section={"reporting"}
          path={`${APP_PREFIX_PATH}/transaction-reporting/`}
          component={lazy(() =>
            import("./ReportingsPage/TransactionReportingPage")
          )}
          exact
        />
        <PrivateRoute
          section={"reporting"}
          path={`${APP_PREFIX_PATH}/marketing/`}
          component={lazy(() => import("./ReportingsPage/MarketingPage/"))}
          exact
        />
        <PrivateRoute
          section={"reporting"}
          path={`${APP_PREFIX_PATH}/services/`}
          component={lazy(() => import("./ReportingsPage/ServicesPage"))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/rooms/`}
          component={lazy(() => import("./Equipment"))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/memberships/`}
          component={lazy(() => import("./MembershipsPage"))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/memberships/library`}
          component={lazy(() => import("./MembershipsPage/Library"))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/gift-cards/`}
          component={lazy(() => import("./GiftCardsPage"))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/gift-cards/templates`}
          component={lazy(() => import("./GiftCardsPage/Templates/index"))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/gift-card-issue`}
          component={lazy(() => import("./GiftCardsPage/Issue/index"))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/gift-cards-preview/:id`}
          component={lazy(() => import("./GiftCardsPage/Preview/index"))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/packages`}
          component={lazy(() => import("./Packages"))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/packages/templates`}
          component={lazy(() => import("./Packages/Templates"))}
          exact
        />
        <PrivateRoute
          section={"scheduler"}
          path={`${APP_PREFIX_PATH}/scheduler`}
          component={lazy(() => import(`./CalendarPage/Scheduler`))}
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/virtual-consult/`}
          component={lazy(() => import(`./VirtualConsultPage/`))}
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/specials`}
          component={lazy(() => import(`./SpecialsPage`))}
          exact
        />
        <PrivateRoute
          section={"marketing"}
          path={`${APP_PREFIX_PATH}/treatments`}
          component={lazy(() => import(`./ReportingsPage/TreatmentsPage`))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/charting`}
          component={lazy(() => import(`./ChartingPage`))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/charting/builder/:id?`}
          component={lazy(() => import(`./ChartingPage/ChartingBuilder`))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/charting/global-templates`}
          component={lazy(() => import(`./ChartingPage/SelectGlobalTemplates`))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/questionnaires`}
          component={lazy(() => import(`./QuestionnairesPage`))}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/questionnaires/builder/:id?`}
          component={lazy(() =>
            import(`./QuestionnairesPage/QuestionnaireBuilder`)
          )}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/questionnaires/global-templates`}
          component={lazy(() =>
            import(`./QuestionnairesPage/SelectGlobalQuestionnaireTemplates`)
          )}
          exact
        />
        <PrivateRoute
          section={"my-practice"}
          path={`${APP_PREFIX_PATH}/questionnaires/kiosk`}
          component={lazy(() => import(`./QuestionnaireKioskPage`))}
          exact
        />
        <Redirect
          from={`${APP_PREFIX_PATH}`}
          to={`${APP_PREFIX_PATH}/contacts`}
        />
      </Switch>
    </Suspense>
  );
};

export default React.memo(AppViews);
